import { useFormikContext } from "formik"
import { FormHelperText } from "@mui/material"

import { FormikDatePicker } from "../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { CreateUpdatePaymentLinkFormValues } from "../paymentLinksTypes"

export function AvailabilityDetailsField() {
    const { values, errors } = useFormikContext<CreateUpdatePaymentLinkFormValues>()
    const { availabilityDetails } = values
    const dateIntervalError =
        typeof errors.availabilityDetails?.dateInterval === "string" ? errors.availabilityDetails.dateInterval : null

    return (
        <>
            <LocalizedStrict id="payment-links-form-availability-from-date-picker" attrs={{ label: true }}>
                <FormikDatePicker
                    name="availabilityDetails.dateInterval.from"
                    range="all"
                    label="From date"
                    maxDate={availabilityDetails?.dateInterval?.to}
                />
            </LocalizedStrict>
            <LocalizedStrict id="payment-links-form-availability-to-date-picker" attrs={{ label: true }}>
                <FormikDatePicker
                    name="availabilityDetails.dateInterval.to"
                    range="all"
                    label="To date"
                    minDate={availabilityDetails?.dateInterval?.from}
                />
            </LocalizedStrict>
            {dateIntervalError && <FormHelperText error>{dateIntervalError}</FormHelperText>}
        </>
    )
}
